
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

import {SyncHistoryService} from '../../../../../modules/sync-history/services/sync-history.service';
import {FileService} from '../../../../../modules/files/services/file.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common'

@Component({
  selector: 'app-log-download-cell-renderer',
  templateUrl: `./log-download-cell-renderer.component.html`,
  styleUrls: [`./log-download-cell-renderer.component.scss`]
})
export class LogDownloadCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  data: any;
  state = 'UNKNOWN';

  constructor(public fileService: FileService,
              private syncHistory: SyncHistoryService,
              private snackBar: MatSnackBar,
              private location: Location
              ) { }

  agInit(params: any): void {
    this.params = params;
    if (params.data && params.data.runId && params.data.runId !== 'NONE') {
      this.data = params.data;
      if(this.data.deepLinkExecutionId === this.data.runId){
        this.getSingleLog(false);
        this.location.go('/sync/jobs');
      }
    }
  }

  refresh(params: any): boolean {
    return true;
  }

  async getSingleLog(rerender = true): Promise<void> {
    await this.params.context.componentParent.loadSingleLog(this.data, false, rerender);
  }

}
